import { Environment } from "../../../environment";
import { Api, IPaginacao } from "../axios-config";

export interface ICliente {
    cnpj: string,
    nome: string,
}

type TCliente = {
    clientes: ICliente[];
    paginacao: IPaginacao;
}

const getAll = async (page = 1, estado: boolean): Promise<TCliente | Error> => {
    try {
        const { data } = await Api.get(`Cliente?estado=${estado}&PageNumber=${page}&PageSize=${Environment.LIMITE_DE_LINHAS}`);

        if (data) {
            return {
                clientes: data.clientes,
                paginacao: data.paginacao,
            }
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const toggleEnabledByCnpj = async (cnpj: string): Promise<void | Error> => {
    try {
        await Api.patch(`Cliente/alterarEstado?cnpj=${cnpj}`);
    } catch (error) {
        console.error(error);

        return new Error((error as { message: string }).message || 'Erro ao habilitar/desabilitar o registro');
    }
};

const list = async (): Promise<ICliente[] | Error> => {
    try {
        const { data } = await Api.get('Cliente?estado=true&listar=true');

        if (data) {
            return data
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar os registros');
    }
}

const getByCnpj = async (cnpj: string): Promise<ICliente | Error> => {
    try {
        const { data } = await Api.get(`Cliente/cnpj?cnpj=${cnpj}`);

        if (data) {
            return data;
        }

        return new Error('Erro ao listar os registros');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao listar o registro');
    }
}

const create = async (dados: object): Promise<string | Error> => {
    try {
        const { data } = await Api.post<ICliente>('/Cliente', dados);

        if (data) {
            return data.cnpj;
        }

        return new Error('Erro ao criar o registro');
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao criar o registro');
    }
};

const updateByCnpj = async (dados: ICliente): Promise<void | Error> => {
    try {
        await Api.put(`Cliente`, dados);
    } catch (error) {
        console.error(error);

        //mostrar a mensagem que o back end retornou, caso não tenha retorna uma mensagem padrão
        return new Error((error as { message: string }).message || 'Erro ao atualizar o registro');
    }
};

export const ClienteService = {
    getAll,
    toggleEnabledByCnpj,
    list,
    getByCnpj,
    create,
    updateByCnpj,
}